import { Component, AfterViewInit, AfterViewChecked, NgZone, ViewChild, ChangeDetectorRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import { TdLoadingService, TdMediaService, TdDialogService, } from '@covalent/core';

import { Patron } from '../../../../../models/';

import { MasterService, LoginService, PatronesService } from '../../../../../services/';
import { Pregunta } from '../../../../../models/pregunta';

@Component({
  selector: 'qs-altacerrados',
  templateUrl: './altacerrados.component.html',
  viewProviders: [PatronesService],
})

export class AltaCerradosComponent implements AfterViewInit, AfterViewChecked {

  public patron: any;
  public titulo: string;
  public idPaciente: string;
  public texto: string;
  public testForm: NgForm;
  public mode: string;
  public idPatron: string;
  public sub: any;
  public test: Patron[] = [];
  // public preguntas: Pregunta[] = [];

  constructor(private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _loginService: LoginService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _dialogService: TdDialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _patronesService: PatronesService) {
  }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('altacerrados.load');
    this._changeDetectorRef.detectChanges();
    let idPatron: number = this.patron.idPatron;
    this.titulo = this.patron.textoPatron;

    this._patronesService.obtenerTestPorId(idPatron.toString()).subscribe((res: any) => {
      this.test.push(res.patron[0]);
      // this.preguntas = this.test[0].preguntas;
      this._loadingService.resolve('altacerrados.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo test.', 'OK', 6000);
      this._loadingService.resolve('altacerrados.load');
    });

    if (this.mode === 'edit') {
      // TODO: PENDIENTE
    } else {
      this.mode = 'add';
    }

    this._loadingService.resolve();
  }

  /**
   * FIX: Esto es un fix para ExpressionChangedAfterItHasBeenCheckedError
   * Aparece al cargar un componente de la vista con datos desde un servicio
   */
  ngAfterViewChecked(): void {
    this._changeDetectorRef.detectChanges();
  }

  delete(form: NgForm): void {
    this.mode = 'del';
    this.save(form);
  }

  save(form: NgForm): void {
    this._loadingService.register();
    this._loadingService.resolve();
  }

  close(): void {
    this._dialogService.closeAll();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/modanamnesis/cerrados/altacerrados/altacerrados.component.ts